import React, { useState, useRef } from 'react';
import UserList, { UserListRef } from '../../components/UserList/index';
import UserCreationModal from '../../components/UserCreation/index';
import { User } from '../../services/UserService';
import AdminLayout from '../../components/AdminLayout';

const addUserBtn: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
  background: 'linear-gradient(120deg, #0b3d91, #1e68ff)', color: '#fff', border: 'none',
  borderRadius: '10px', padding: '8px 14px', fontWeight: 700, cursor: 'pointer',
  boxShadow: '0 6px 18px rgba(14,52,161,0.35)', transition: 'transform 0.15s ease, box-shadow 0.15s ease', fontSize: '0.85rem',
};

const UserPage: React.FC = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const userListRef = useRef<UserListRef>(null);

  const handleUserSelect = (_user: User) => { setIsEditing(true); setIsCreating(false); };
  const handleOpenCreationModal = () => { setIsCreating(true); setIsEditing(false); };
  const handleCloseCreationModal = () => { setIsCreating(false); };
  const handleUserCreated = () => { setIsCreating(false); userListRef.current?.fetchUsers(); };

  return (
    <AdminLayout>
      <div className="px-6 py-6 max-w-[1400px] mx-auto">
        <div className="flex justify-between items-center mb-6 pb-4 border-b border-[rgba(120,190,255,0.18)]">
          <div>
            <h1
              className="m-0 text-3xl font-bold"
              style={{ color: '#0b1a30' }}
            >
              Gerenciamento de Usuários
            </h1>
          </div>
          {!isEditing && (
            <button style={addUserBtn} onClick={handleOpenCreationModal} className="hover:-translate-y-px">
              + Adicionar Usuário
            </button>
          )}
        </div>

        <UserList ref={userListRef} onUserSelect={handleUserSelect} />

        <UserCreationModal open={isCreating} onClose={handleCloseCreationModal} onUserCreated={handleUserCreated} />
      </div>
    </AdminLayout>
  );
};

export default UserPage;
